import { render, staticRenderFns } from "./ConfirmValues.vue?vue&type=template&id=bbc28034&scoped=true"
import script from "./ConfirmValues.vue?vue&type=script&lang=js"
export * from "./ConfirmValues.vue?vue&type=script&lang=js"
import style0 from "./ConfirmValues.vue?vue&type=style&index=0&id=bbc28034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc28034",
  null
  
)

export default component.exports